import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Login         from './pages/Login';
import Layout        from './components/Layout';
import NoNumberGuard from './components/NoNumberGuard';
import Inbox         from './pages/Inbox';
import Templates     from './pages/Templates';
import Flows         from './pages/Flows';
import Send          from './pages/Send';
import ApiDocs       from './pages/ApiDocs';
import Settings      from './pages/Settings';
import Businesses    from './pages/Businesses';
import Analytics    from './pages/Analytics';
import Webhooks     from './pages/Webhooks';
import Users         from './pages/Users';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('wa_token');
  return token ? children : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="/businesses" replace />} />
          <Route path="businesses" element={<Businesses />} />
          <Route path="inbox"      element={<NoNumberGuard><Inbox /></NoNumberGuard>} />
          <Route path="send"       element={<NoNumberGuard><Send /></NoNumberGuard>} />
          <Route path="templates"  element={<NoNumberGuard><Templates /></NoNumberGuard>} />
          <Route path="flows"      element={<NoNumberGuard><Flows /></NoNumberGuard>} />
          <Route path="analytics"  element={<NoNumberGuard><Analytics /></NoNumberGuard>} />
          <Route path="webhooks"   element={<Webhooks />} />
          <Route path="api-docs"   element={<ApiDocs />} />
          <Route path="settings"   element={<Settings />} />
          <Route path="users"      element={<Users />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
